import { gql } from '@apollo/client';

export const CREATE_WEBHOOK = gql`
  mutation createNewWebhook(
    $eventTypeCode: String!
    $schemeId: String!
    $hirerId: String
    $url: String!
    $maxEventsPerAttempt: Int
    $signingAlgorithmCode: String!
    $secret: String!
  ) {
    createWebhookSubscription(
      input: {
        webhookSubscription: {
          eventTypeCode: $eventTypeCode
          schemeId: $schemeId
          hirerId: $hirerId
          url: $url
          maxEventsPerAttempt: $maxEventsPerAttempt
          signingAlgorithmCode: $signingAlgorithmCode
          secret: $secret
        }
      }
    ) {
      ... on CreateWebhookSubscriptionPayload_Success {
        __typename
        webhookSubscription {
          id {
            value
          }
          eventTypeCode
          url
        }
      }

      ... on CreateWebhookSubscriptionPayload_Conflict {
        __typename
        conflictingWebhookSubscription {
          id {
            value
          }
        }
      }
    }
  }
`;

export const GET_HIRER_SCOPED_WEBHOOK_SUBSCRIPTION_COUNT = gql`
  query GetHirerScopedWebhookSubscriptionCount($schemeId: String!) {
    webhookSubscriptions(
      filter: { hirerScopedIndicator: true }
      schemeId: $schemeId
    ) {
      totalCount
    }
  }
`;
